import Feature from "ol/Feature";
import VectorSource from 'ol/source/Vector';

//console.log(feature.getLayer(map));
Feature.prototype.getLayer = function(map) {
    var this_ = this, layer_;
    var sameFeature = function(feature){
        return (this_ === feature) ? true : false;
    };
   map.getLayers().forEach(function(layer){
//	    console.log('rj',layer);
	   if(layer.getSource)   {

        var source = layer.getSource();
if(source instanceof VectorSource){
            var features = source.getFeatures();
            if(features.length > 0){
                var found = features.some(sameFeature);
                if(found){
    //                layer_ = layer;
                }
            }
        }
	    }
	    else{
	    if(layer.getLayers)   {
		    layer.getLayers().forEach(function(sublayer){ 
			    if(sublayer.getSource)   {
				    var source = sublayer.getSource();
				    if(source instanceof VectorSource){
					    var features = source.getFeatures();
					    //console.log('group',sublayer);
					    if(features.length > 0){
						    var found = features.some(sameFeature);
						    if(found){
							    layer_ = sublayer;
						    }
					    }
				    }
			    }
		    });
	    }
    }
   });
    return layer_;
};

